export enum VerifiedBadgeType {
  VERIFIED = 'verified-v2.svg',
  PARTIALLY_VERIFIED = 'partially-verified-v3.svg',
}
